import React from "react";
import logoBancodobrasil from '../../../assets/images/partners/logo_bancodobrasil.webp';
import logoCaixa from '../../../assets/images/partners/logo_caixa.webp';
import logoSantander from '../../../assets/images/partners/logo_santander.webp';
import './PartnersGrid.css';

const PartnersGrid = () => {
  return (
    <section id="parceiros" className="partners section">
      <div className="container">
        <div className="partners-content">

          <div className="left-content">
            <h1 className="title">
              Quem tá junto
            </h1>

            <p className="subtitle">
              Fazendo acontecer
            </p>
          </div>

          <div className="partners-logos">

            <div className="partner-logo">
              <img src={logoSantander} alt="Santander" />
            </div>

            <div className="partner-logo">
              <img src={logoCaixa} alt="Banco Caixa" />
            </div>

            <div className="partner-logo">
              <img src={logoBancodobrasil} alt="Banco do Brasil" />
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default PartnersGrid;